import React from 'react'
import { Modal } from 'react-bootstrap';
import { useSwipeClose } from '../../hooks/useSwipeClose';

const MarketOutcomesMobileModal = ({ show, onHide, options = [], poolsdetail, theme, getBackgroundColor }) => {
    const swipeRef = useSwipeClose(show, onHide);
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="pollmodal sharesocial-modal market-outcome-modal-mobile new-modal-style"
            animation={false}
        >
            <Modal.Header onClick={onHide} ref={swipeRef}>
                <div className="close-div"></div>
            </Modal.Header>
            <Modal.Body>
                <div className="parent">
                    <div className="main-heading">
                        <h4>Outcomes</h4>
                    </div>
                    <div className="bottom-outcomes">
                        {options.map((opt, i) => {
                            const optIndex = poolsdetail?.options?.findIndex(o => o._id === opt._id) ?? i;
                            return (
                                <div className="single-outcome" key={opt._id || i}>
                                    <div className="left-inline">
                                        <span
                                            className="dot-color"
                                            style={{ backgroundColor: getBackgroundColor(optIndex, theme, poolsdetail?.options?.length) }}
                                        ></span>
                                        <h6>{opt?.optionName}</h6>
                                    </div>
                                    <div className="right-inline">
                                        <p>{opt?.percentage || 0}%</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MarketOutcomesMobileModal;